import React, { useState } from "react";
import { Image, Tag } from "antd";
import ProfileContainer from "../components/ProfileContainer";
import ProfileBrand from "../components/ProfileBrand";
import { PictureOutlined } from "@ant-design/icons";
import FlipMove from "react-flip-move";

const MAX_LENGTH = 3;

const colorMap = {
    industries: 'default',
    skills: 'geekblue',
    disciplines: 'purple'
};


const AgencyProfileServicesOffered = ({ items, agency }) => {
    const [isOpen, setIsOpen] = useState(true);
    const keyServices = TB.sortBy(items, 'display_index');
    return (
        <div id="services-offered" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Services
                        Offered {!!keyServices.length && `(${keyServices.length})`}</h4>

                    {!keyServices.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Services Available</p>
                        </div>
                    )}
                    {keyServices.length && (
                        <div className="border-t pb-8" />
                    )}

                    <div className="flex gap6 flex-wrap divide-y">
                        {keyServices?.slice(0, isOpen ? keyServices.length : MAX_LENGTH).map(service => {
                            return (
                                <ProfileServiceRow
                                    key={service.id}
                                    service={service}
                                    keyClients={agency.key_clients}
                                />
                            )
                        })}
                    </div>

                </div>
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfileServicesOffered;


const serviceFeeFormatter = (type, amount) => {
    const serviceType = laravel.service_fee_types[type];
    if (serviceType === 'Fixed Rate') return `Starting at ${TB.formatCurrency(amount)}/hr`;
    if (serviceType?.includes('Ongoing')) return `Starting at ${TB.formatCurrency(amount)}`;
    // if (serviceType === 'Must Contact') return 'Contact For Pricing';
    return 'Contact For Pricing';
}

const getPDFAssets = (service) => {
    return service?.assets?.filter(asset =>
        asset.content_type === "PDF"
    ) || [];
};

const getMediaAssets = (service) => {
    const assets = service?.assets?.filter(asset =>
        (asset.content_type === "Image" || asset.content_type === "Video") && asset.path
    ) || [];

    assets.unshift({ path: service.image_path, caption: service.tag_line, id: service.id })
    return assets;
};
const ProfileServiceRow = ({ service, keyClients = [] }) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(true);
    const [visible, setVisible] = useState(false);

    const sharedKeyClientIds = TB.map(service.key_clients || [], 'id');
    const existingClients = TB.filter(keyClients, keyClient => sharedKeyClientIds.includes(keyClient.id));

    return (
        <div className="first:pt-0 mb-8 pt-6 flex flex-col gap-4">
            <div className="flex gap-4 justify-between">
                <div className="flex flex-col gap-3">
                    <p className="text-lg font-medium">{service.name}</p>
                    <p className="text-base italic font-medium">{service.tag_line}</p>
                </div>


                <div className="bg-gray-200 rounded-full py-1 px-4 flex self-start">
                    {/* <p>Starting at {TB.formatCurrency(service.fee_amount)}</p> */}
                    <p className="whitespace-nowrap -mb-0.5">{serviceFeeFormatter(service.fee_type, service.fee_amount)}</p>
                </div>
            </div>
            <div className="flex flex-row gap-4">
                {/* {service.image_path && ( */}
                    <div className="basis-2/3 flex flex-col items-stretch">
                        <Image src={service.image_path || '/images/service_offering.png'} // src={service.image_path}
                            alt={`${service.name} highlight`}
                            className="w-full"
                        />
                    </div>

                {/* )} */}

                {/*<div className="relative">*/}
                {/*    <Image*/}
                {/*        preview={service.image_path ? { visible: false } : false}*/}
                {/*        wrapperClassName="border border-gray-300"*/}
                {/*        src={service.image_path || '/images/talent/project-case-studies-default.jpeg'}*/}
                {/*        className={TB.mapClass("object-cover transition-transform aspect-video", { "hover:scale-105": !!service.image_path })}*/}
                {/*        fallback='/images/talent/project-case-studies-default.jpeg'*/}
                {/*        onClick={() => service.image_path && setVisible(true)}*/}
                {/*    />*/}
                {/*    {getMediaAssets(service)?.length > 1 && (*/}
                {/*        <div*/}
                {/*            className="pointer-events-none absolute bottom-3 right-2 rounded-md px-1.5 py-1.5 flex flex-row gap-1.5 items-end justify-center bg-black bg-opacity-60">*/}
                {/*            <PictureOutlined className="text-white text-base" />*/}
                {/*            <div className="text-xs text-white">*/}
                {/*                {getMediaAssets(service)?.length}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*    {getMediaAssets(service)?.length >= 1 && (*/}
                {/*        <div style={{ display: 'none' }}>*/}
                {/*            <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>*/}
                {/*                {getMediaAssets(service).map(img => <Image key={img.path} src={img.path} />)}*/}
                {/*            </Image.PreviewGroup>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/* Services Section */}
                {service.service_tags && service.service_tags.length > 0 && (
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold">Services</h4>
                        {/* Service Tags Display */}
                        {service.service_tags && service.service_tags.length > 0 && (() => {
                            const groupedTags = {};
                            service.service_tags.forEach(tag => {
                                if (!groupedTags[tag.category]) {
                                    groupedTags[tag.category?.name || tag.category] = [];
                                }
                                groupedTags[tag.category?.name || tag.category].push(tag);
                            });

                            return (
                                <div className="space-y-4">
                                    {Object.keys(groupedTags).map(categoryName => (
                                        <div key={categoryName} className="category-group">
                                            <h6 className="text-sm font-medium text-gray-600 mb-2">{categoryName}</h6>
                                            <div className="discipline-skills-container">
                                                <FlipMove typeName={null} maintainContainerHeight={true}>
                                                    {TB.map(groupedTags[categoryName], (tag, tagIndex) => (
                                                        <Tag
                                                            key={tag.id}
                                                            color="cyan"
                                                            closable={false}
                                                            className="mr-3 my-1.5"
                                                        >
                                                            {tag.name}
                                                        </Tag>
                                                    ))}
                                                </FlipMove>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                )}
                {(!!service.disciplines?.length || !!service.skills?.length || !!service.industries?.length) && isDetailsOpen && (
                    <div className="basis-1/3">
                        <div className="flex flex-col items-start gap-2">
                            {service.disciplines?.length > 0 && (
                                <div className="flex flex-row flex-wrap items-start gap-2">
                                    {service.disciplines.map(disc => (
                                        <Tag color={colorMap.disciplines} key={disc.id} className="m-0">
                                            {disc.name}
                                        </Tag>
                                    ))}
                                </div>
                            )}

                            {service.skills?.length > 0 && (
                                <div className="flex flex-row flex-wrap items-start gap-2">
                                    {service.skills.map(skill => (
                                        <Tag color={colorMap.skills} key={skill.id} className="m-0">
                                            {skill.name}
                                        </Tag>
                                    ))}
                                </div>
                            )}

                            {service.industries?.length > 0 && (
                                <div className="flex flex-row flex-wrap items-start gap-2">
                                    {service.industries.map(industry => (
                                        <Tag color={colorMap.industries} key={industry.id} className="m-0">
                                            {industry.name}
                                        </Tag>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-7">
                <div>
                    <p dangerouslySetInnerHTML={{ __html: TB.stripHtml(service.summary)?.length > 0 ? service.summary : '<i class="text-gray-400">Not provided</i>' }} />
                </div>


                {!!service.brands.length && (
                    <div className="flex flex-col gap-4">
                        <p className="font-medium border-b border-b-gray-300 pb-1.5">Client Examples</p>
                        <div className="flex gap-5 flex-wrap">
                            {service.brands.map(brand => {
                                return (
                                    <ProfileBrand brand={brand} showTooltip={true}
                                        className="!max-w-[80px] [&_img]:max-h-20 max-h-20 !h-14 !px-1.5 !py-1.5 relative"
                                        key={brand.id} />
                                )
                            })}
                        </div>
                    </div>
                )}

                {!!existingClients.length && (
                    <div className="flex flex-col gap-4">
                        <p className="font-medium border-b border-b-gray-300 pb-1.5">Project Highlights</p>
                        <div className="flex flex-col items-start gap-4">
                            {existingClients.map(client => {
                                return (
                                    <div key={client.id} className="w-full">
                                        <p className="text-xs font-medium pb-1">{client.headline}</p>

                                        <div
                                            className="items-start gap-5 flex-wrap grid gridcols-2 grid-cols-[auto_1fr]">
                                            <div className="flex gap-2">
                                                {client.brands.slice(0, 2).map(brand => (
                                                    <ProfileBrand
                                                        brand={brand} showTooltip={true}
                                                        className="!max-w-[80px] [&_img]:max-h-20 max-h-[80px] !h-14 !px-1.5 !py-1.5 relative"
                                                        key={brand.id} />
                                                ))}
                                            </div>
                                            <p className="text-wrippleBlueGray text-xxs line-clamp-3">{TB.stripHtml(client.description)}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

                {TB.stripHtml(service.process)?.length > 0 && isDetailsOpen && (
                    <div className="flex flex-col gap-4">
                        <p className="font-medium border-b border-b-gray-300 pb-1.5">Process</p>
                        <div className="text-sm"
                            dangerouslySetInnerHTML={{ __html: service.process }} />
                    </div>
                )}

                {!!service.deliverables?.length && (
                    <div className="flex flex-col gap-4">
                        <p className="font-medium border-b border-b-gray-300 pb-1.5">Deliverables</p>
                        <div className="flex flex-col items-start gap-4">
                            {service.deliverables?.map(deliv => {
                                return (
                                    <div key={deliv.name}>
                                        <p className="text-sm pb-2">{deliv.name}</p>
                                        <p className="text-xs text-wrippleBlueGray">{deliv.description}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

                {!!service.faqs?.length && (
                    <div className="flex flex-col gap-4">
                        <p className="font-medium border-b border-b-gray-300 pb-1.5">FAQs</p>
                        <div className="flex flex-col items-start gap-4">
                            {service.faqs.map(faq => {
                                return (
                                    <div key={faq.question + faq.answer}>
                                        <p className="text-sm pb-2">{faq.question}</p>
                                        <p className="text-xs text-wrippleBlueGray">{faq.answer}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}

            </div>


            {/*<button type="button" className="btn btn-primary" onClick={() => setIsDetailsOpen(!isDetailsOpen)}>*/}
            {/*    View Details*/}
            {/*</button>*/}

        </div>
    )
}

export {
    ProfileServiceRow
}